import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8 16H4C3.45 16 3 15.55 3 15C3 14.45 3.45 14 4 14H8C8.55 14 9 14.45 9 15C9 15.55 8.55 16 8 16ZM4 6C3.45 6 3 5.55 3 5C3 4.45 3.45 4 4 4H20C20.55 4 21 4.45 21 5C21 5.55 20.55 6 20 6H4ZM14 11H4C3.45 11 3 10.55 3 10C3 9.45 3.45 9 4 9H14C14.55 9 15 9.45 15 10C15 10.55 14.55 11 14 11ZM19 12C19 11.4477 18.5523 11 18 11C17.4477 11 17 11.4477 17 12V18.5858L15.7071 17.2929C15.3166 16.9024 14.6834 16.9024 14.2929 17.2929C13.9024 17.6834 13.9024 18.3166 14.2929 18.7071L17.2929 21.7071C17.6834 22.0976 18.3166 22.0976 18.7071 21.7071L21.7071 18.7071C22.0976 18.3166 22.0976 17.6834 21.7071 17.2929C21.3166 16.9024 20.6834 16.9024 20.2929 17.2929L19 18.5858V12Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2.565 2.93994C2.25296 2.93994 2 3.1929 2 3.50494C2 3.81698 2.25296 4.06994 2.565 4.06994H13.435C13.747 4.06994 14 3.81698 14 3.50494C14 3.1929 13.747 2.93994 13.435 2.93994H2.565ZM2.565 5.93994C2.25296 5.93994 2 6.1929 2 6.50494C2 6.81698 2.25296 7.06994 2.565 7.06994H9.435C9.74704 7.06994 10 6.81698 10 6.50494C10 6.1929 9.74704 5.93994 9.435 5.93994H2.565ZM2 9.50494C2 9.1929 2.25296 8.93994 2.565 8.93994H5.435C5.74704 8.93994 6 9.1929 6 9.50494C6 9.81698 5.74704 10.0699 5.435 10.0699H2.565C2.25296 10.0699 2 9.81698 2 9.50494ZM13.0651 7.00006C13.0651 6.68802 12.8121 6.43506 12.5001 6.43506C12.188 6.43506 11.9351 6.68802 11.9351 7.00006V11.636L10.8996 10.6005C10.6789 10.3799 10.3212 10.3799 10.1005 10.6005C9.8799 10.8212 9.8799 11.1789 10.1005 11.3996L12.1005 13.3996C12.3212 13.6202 12.6789 13.6202 12.8996 13.3996L14.8996 11.3996C15.1202 11.1789 15.1202 10.8212 14.8996 10.6005C14.6789 10.3799 14.3212 10.3799 14.1005 10.6005L13.0651 11.636V7.00006Z"
  />
);

export const SortZAIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="SortZA" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
